import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import CamposBanco, { BANCO_VACIO, clabeValida } from "./CamposBanco";

function NavierasCreate() {
  const { user } = useContext(AuthContext);
  const URL_NAVIERAS = process.env.REACT_APP_URL_NAVIERAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const [name, setName] = useState("");
  const [diasLibresDemoras, setDiasLibresDemoras] = useState("");
  const [bancarios, setBancarios] = useState(BANCO_VACIO);
  const [text, setText] = useState(false);
  const [validaBoton, setValidaBoton] = useState(true);
  const [t, i18n] = useTranslation("global");

  const clear = () => {
    setName("");
    setDiasLibresDemoras("");
    setBancarios(BANCO_VACIO);
  };

  const saveNavieras = (event) => {
    event.preventDefault();
    if (!clabeValida(bancarios.clabe)) {
      Swal.fire({ icon: "warning", title: t("La Clabe debe tener 18 dígitos") });
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        URL_NAVIERAS,
        {
          name,
          diasLibresDemoras: diasLibresDemoras === "" ? null : Number(diasLibresDemoras),
          ...bancarios,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Naviera",
            detalle: name,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        clear();
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <Form onSubmit={saveNavieras}>
          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-plus-circle" /><h4 className="form-section-title">{t("Crea una nueva Naviera")}</h4></div>
            <div className="form-section-body">
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
            <Label for="exampleEmail" className="mr-sm-2">
              {t("Naviera")}
            </Label>
            <Input
              type="text"
              name="email"
              
              value={name}
              required
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </FormGroup>
          <FormGroup className="mb-2 mr-sm-2 mb-sm-0 mt-2">
            <Label className="mr-sm-2">{t("Días libres demoras")}</Label>
            <Input
              type="number"
              min="0"
              placeholder="Ej. 21"
              value={diasLibresDemoras}
              onChange={(e) => setDiasLibresDemoras(e.target.value)}
            />
          </FormGroup>
            </div>
          </div>
          <div className="form-section">
            <div className="form-section-header"><i className="fas fa-university" /><h4 className="form-section-title">{t("Datos bancarios")}</h4></div>
            <div className="form-section-body">
              <CamposBanco valores={bancarios} set={(campo, valor) => setBancarios((b) => ({ ...b, [campo]: valor }))} />
            </div>
          </div>
          <div className="submit-bar">
            {validaBoton ? (
              <Button type="submit" color="success">
                <i className="fas fa-save" /> {t("Guardar")}
              </Button>
            ) : (
              <Button type="submit" color="success" disabled>
                <i className="fas fa-save" /> {t("Guardar")}
              </Button>
            )}
            <div>
              <SweetAlert
                show={text}
                title="Creado con Exito"
                onConfirm={() => {
                  setText(false);
                }}
              />
            </div>
            <Button color="secondary" href="/MenuCatalogos">
              <i className="fas fa-arrow-left" /> {t("Regresar")}
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default NavierasCreate;
